import { useParams, Navigate, Link } from "react-router-dom";
import Seo from "../components/Seo";
import { CTABand } from "../components/bits";
import { ARTICLES } from "../content/pages";
import { SITE } from "../content/site";

export default function Article() {
  const { slug } = useParams();
  const a = ARTICLES.find((x) => x.slug === slug);
  if (!a) return <Navigate to="/insights" replace />;

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: a.title,
    description: a.description,
    datePublished: a.date,
    author: { "@type": "Organization", name: SITE.brand },
  };

  return (
    <>
      <Seo path={`/insights/${a.slug}`} title={a.title} description={a.description} jsonLd={jsonLd} />
      <article className="mx-auto max-w-3xl px-4 py-16 sm:px-8 sm:py-20" data-testid={`article-${a.slug}`}>
        <p className="font-mono text-xs text-brand-slate">{a.date} · {a.readingTime} read · <Link to="/insights" className="text-primary hover:underline">Insights</Link></p>
        <h1 className="mt-4 text-4xl font-semibold tracking-tight text-brand-navy sm:text-5xl">{a.title}</h1>
        <div className="mt-10 space-y-6">
          {a.blocks.map((b, i) => {
            if (b.t === "h") return <h2 key={i} className="pt-4 text-2xl font-semibold tracking-tight text-brand-navy">{b.c}</h2>;
            if (b.t === "list") return (
              <ul key={i} className="space-y-3">
                {b.c.map((li) => (
                  <li key={li} className="flex items-start gap-3 text-base leading-relaxed text-brand-slate">
                    <span className="mt-2.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-primary" aria-hidden="true" />{li}
                  </li>
                ))}
              </ul>
            );
            return <p key={i} className="text-base leading-relaxed text-brand-slate">{b.c}</p>;
          })}
        </div>
        <div className="mt-14 rounded-sm border border-border bg-brand-surface p-6">
          <p className="text-sm font-semibold text-brand-navy">Put it to the test</p>
          <p className="mt-2 text-sm leading-relaxed text-brand-slate">Reading only gets you so far. A four-question selector gives a first steer, and a pilot proves it on your lanes.</p>
          <div className="mt-4 flex flex-wrap gap-3">
            <Link to="/compare-smart-labels" data-testid="article-cta-selector" className="rounded-sm border border-brand-navy/20 bg-white px-5 py-2.5 text-sm font-semibold text-brand-navy hover:border-primary hover:text-primary">Try the selector</Link>
            <Link to="/request-a-pilot" data-testid="article-cta-pilot" className="rounded-sm bg-primary px-5 py-2.5 text-sm font-semibold text-white hover:bg-blue-700">Discuss your shipment</Link>
          </div>
        </div>
      </article>
      <CTABand />
    </>
  );
}
